import {
  createTranslatedMessageComponent,
  createUseTranslateMessage,
  useSafeIntl,
} from '@bloomberg/media.i18n';

import { labelIds } from '../i18n';

export const useTranslateMessage = createUseTranslateMessage(labelIds);

export const TranslatedMessage = createTranslatedMessageComponent(labelIds);

export const useIntl = useSafeIntl;
